import News from './News.jsx';

export {
  News
}


// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/news/index.js